export default __webpack_public_path__ + "static/media/usdt.536fb283.svg";